import React from 'react';
import StethoscopeLoading from '../StethoscopeLoading/StethoscopeLoading';

const LoadingSpinner = () => {
    return <StethoscopeLoading />;
};

export default LoadingSpinner; 